import React from "react";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import styles from "./styles.module.css";
import { printReceipt } from "./constants";

const BulkPrintReceipt = ({
  rows,
  selectionModel,
  setSelectionModel,
  setIsGeneratingReceipt,
}) => {
  const handleBulkPrint = async () => {
    setIsGeneratingReceipt(true);

    const selectedReceipts = rows.filter((item) =>
      selectionModel.includes(item.rowNumber)
    );

    // single/bulk receipt
    await printReceipt({
      receipts: selectedReceipts,
    });
    setIsGeneratingReceipt(false);

    // reset checkbox selection
    setSelectionModel([]);
  };

  return (
    <div
      className={`${styles?.bulk_footer}`}
      style={{ backgroundColor: selectionModel.length ? "#004662" : "#757575" }}
    >
      <div>
        {selectionModel.length ? (
          <>
            <span> Selected Receipts </span>
            <span className="heading-4"> {selectionModel?.length}</span>
          </>
        ) : (
          "Select receipts to print"
        )}
        <br />
        <small className="regular-small">
          (Max 10 receipts can be selected)
        </small>
      </div>

      <div>
        <AButton
          variant="primary_filled"
          size="sm"
          updatedStyle={{
            fontWeight: "700",
          }}
          disabled={selectionModel.length <= 0}
          onClick={() => handleBulkPrint()}
        >
          Print receipt
        </AButton>
      </div>
    </div>
  );
};

export default BulkPrintReceipt;
